/**
 * Format duration from minutes to "XhXX" format
 * Examples: 60 -> "1h00", 75 -> "1h15", 30 -> "30min"
 */
export const formatDuration = (minutes: string | number): string => {
  const numMinutes = typeof minutes === 'string' 
    ? parseInt(minutes.replace(/\D/g, ''), 10) 
    : minutes;
  
  if (isNaN(numMinutes)) return '';
  
  if (numMinutes < 60) {
    return `${numMinutes}min`;
  }
  
  const hours = Math.floor(numMinutes / 60);
  const mins = numMinutes % 60;
  
  return mins > 0 ? `${hours}h${mins.toString().padStart(2, '0')}` : `${hours}h00`;
};

/**
 * Format price to "X€" format
 * Examples: 55 -> "55€", 75.5 -> "75,5€"
 */
export const formatPrice = (price: string | number): string => {
  const numPrice = typeof price === 'string'
    ? parseFloat(price.replace(/[^0-9.,]/g, '').replace(',', '.'))
    : price;
  
  if (isNaN(numPrice)) return '';
  
  // Use French format (comma for decimals)
  const formatted = numPrice.toString().replace('.', ',');
  return `${formatted}€`;
};

/**
 * Sanitize duration input - keep only digits
 */
export const sanitizeDuration = (value: string): string => {
  return value.replace(/\D/g, '');
};

/**
 * Sanitize price input - keep only digits, dot and comma
 */
export const sanitizePrice = (value: string): string => {
  return value.replace(/[^0-9.,]/g, '').replace(',', '.');
};
